<div class="drawer-content" [ngClass]="{ 'iphone-style': isIphone }">
  <header class="title-area">
    <app-titulo [titulo]="titulo" [subtitulo]="subtitulo"></app-titulo>
    <mat-icon
      class="close-icon"
      aria-hidden="false"
      aria-label="Example home icon"
      fontIcon="close"
      (click)="cancelar()"></mat-icon>
  </header>
  @if (modalFormService.showingModal | async) {
    <div class="form-area">
      @if (!created()) {
        <app-form-leaflet-draw
          #formParcela
          (isValidForm)="isValidForm($event)"></app-form-leaflet-draw>
      } @else {
        <ng-container [ngTemplateOutlet]="createdItem"></ng-container>
      }
    </div>
  }
  <div class="bottom-area">
    <div class="actions">
      @if (!created()) {
        <app-button-primary
          class="button"
          (clicked)="guardar()"
          [disabled]="disabledPrimaryButton() || isLoading()"
          [spinner]="isLoading()"
          width="100%"
          [label]="labelPrimaryButton">
        </app-button-primary>
      }
      <app-button-secondary
        class="button"
        [disabled]="false"
        (clicked)="cancelar()"
        width="100%"
        [label]="labelSecundaryButton()">
      </app-button-secondary>
    </div>
    <app-error-message [showError]="error()" [error]="error()">
    </app-error-message>
  </div>
</div>

<ng-template #createdItem>
  <div class="created-item">
    <span class="material-symbols-rounded created-item-icon">check_circle</span>
    <div class="div-textos">
      <app-titulo titulo="¡Parcela creada con éxito!"></app-titulo>
      <p class="textos-body-medium">
        Puedes gestionarla desde el Módulo de Gestión, en la sección CCRR,
        dentro de Parcelas, buscándola por su nombre.
      </p>
      <p class="textos-body-medium">
        También puedes acceder directamente a través del siguiente enlace:
        <span class="parcela-details" (click)="verParcelaOdoo()"
          >Ver detalle de la parcela</span
        >
      </p>
    </div>
  </div>
</ng-template>
